var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDanish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 3.25L5.625 18.75L10 16.125L14.375 18.75L14.375 3.25C14.375 2.14543 13.4796 1.25 12.375 1.25L7.625 1.25C6.52043 1.25 5.625 2.14543 5.625 3.25Z",
    fill: "#202B72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanish);
export default __webpack_public_path__ + "static/media/danish.45378eddc7003d57b6e96e489a61305b.svg";
export { ForwardRef as ReactComponent };